import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services';
import { IVaultItem } from '@app/pages/passwordManager/interfaces';
import { infiniteScrollItemsFetchLimit } from '@app/helpers';
import { Order } from '@app/models';

class VaultsServiceNew {
    readonly apiBase: string = '/api/v1/pm/vaults';

    getVaultById(vaultId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/${vaultId}`, {
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch();
    }

    getNotInVaultGroups(orderBy: string, asc: string, vaultId: string, take: number, skip: number, handleError: Function, handleSuccess: Function, search?: string): AxiosPromise {
        const newAsc = asc === Order.asc ? 'a' : 'd'; // TODO: Have to be changed on the back-end

        return apiService
            .get(`${this.apiBase}/${vaultId}/groups/available`, {
                params: {
                    orderBy: orderBy + ' ' + newAsc,
                    take: take,
                    skip: skip,
                    filter: search
                },
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch();
    }

    getVaults(take: number, skip: number, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(this.apiBase, {
                params: {
                    take: take,
                    skip: skip
                },
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch();
    }

    getAllVaults() {
        let values: IVaultItem[] = [];
        let count = 0;

        const getVaultsInfo = (): Promise<IVaultItem[]> => {
            return this.getVaults(
                infiniteScrollItemsFetchLimit,
                count,
                () => {},
                () => {}
            ).then((resp: AxiosResponse) => {
                count += resp.data.items.length;
                values = [...values, ...resp.data.items];

                if (count < resp.data.count) {
                    return getVaultsInfo();
                } else {
                    return values;
                }
            });
        };

        return getVaultsInfo();
    }

    addVault(jsonObject: any, handleError: Function, handleSuccess: Function) {
        return apiService.post(`${this.apiBase}`, jsonObject, { onError: handleError, onSuccess: handleSuccess }).catch();
    }

    updateVaultGroups(jsonObject: any, vaultId: string, handleError: Function, handleSuccess: Function) {
        return apiService.put(`${this.apiBase}/${vaultId}/groups`,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess }
        )
            .catch();
    }

    editVault(jsonObject: any, vaultId: string, handleError: Function, handleSuccess: Function) {
        return apiService.put(`${this.apiBase}/${vaultId}/details`,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess }
        )
            .catch();
    }

    isVaultNameAvailable(search: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(this.apiBase, {
                params: {
                    take: 1,
                    skip: 0,
                    filter: search
                },
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch();
    }
}

export const vaultsServiceNew = new VaultsServiceNew();
